/* eslint import/no-unresolved: 0 */
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

import { setLocalStorage } from '@src/data/localStorage';

const AccessExpirationDateBanner = ({
  courseId, accessExpirationDate, timezoneFormatArgs, setupgradeNotificationCurrentState,
}) => {
  const intl = useIntl();
  if (setupgradeNotificationCurrentState) {
    setupgradeNotificationCurrentState('accessDateView');
    setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'accessDateView');
  }
  return (
    <div className="upsell-warning-light">
      {intl.formatMessage(
        {
          id: 'advertisements.upgradeNotification.expiration',
          defaultMessage: 'Course access will expire {date}',
          description: 'Message notifying user when upgrade deadline will pass',
        },
        {
          date: intl.formatDate(accessExpirationDate, {
            key: 'accessExpireDate',
            day: 'numeric',
            month: 'long',
            ...timezoneFormatArgs,
          }),
        },
      )}
    </div>
  );
};

AccessExpirationDateBanner.propTypes = {
  courseId: PropTypes.string.isRequired,
  accessExpirationDate: PropTypes.PropTypes.instanceOf(Date).isRequired,
  timezoneFormatArgs: PropTypes.shape({
    timeZone: PropTypes.string,
  }),
  setupgradeNotificationCurrentState: PropTypes.func,
};

AccessExpirationDateBanner.defaultProps = {
  timezoneFormatArgs: {},
  setupgradeNotificationCurrentState: null,
};

export default AccessExpirationDateBanner;
